import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_800, BLACK_900, Button, Typography, getTestId, isValidObject, useBreakpoint } from '@airtel/air-design-system';
import { Image, View, Pressable } from 'react-native';
import { CarouselWidgetComponent as CarouselWidget } from '../../components/carousel-widget/CarouselWidget';
import { getInventoryListWidgetStyles } from './InventoryListWidgetStyles';
var inventoryListWidgetStyles = getInventoryListWidgetStyles();
export var InventoryListWidgetComponent = props => {
  var _a;
  var _props$listData = props.listData,
    listData = _props$listData === void 0 ? [] : _props$listData,
    style = props.style,
    carouselWidgetProps = props.carouselWidgetProps,
    onUserAction = props.onUserAction;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var inventoryList = (_a = listData === null || listData === void 0 ? void 0 : listData.map((data, id) => _jsx(View, Object.assign({
    style: inventoryListWidgetStyles.cardContainerOuter
  }, {
    children: _jsx(InventoryList, Object.assign({}, data, {
      onUserAction: onUserAction
    }), 'inventory_' + id)
  }), 'inventory_' + id))) !== null && _a !== void 0 ? _a : [];
  return _jsx(_Fragment, {
    children: !!(listData === null || listData === void 0 ? void 0 : listData.length) && _jsx(View, Object.assign({
      style: [inventoryListWidgetStyles.cardContainer, style]
    }, {
      children: _jsx(CarouselWidget, Object.assign({
        data: inventoryList,
        showIndicators: true,
        indicatorBottomPosition: isSmallScreen ? -14 : -12,
        carouselType: "COMPONENT",
        theme: "light",
        showNavigationCounter: false,
        alignment: "center"
      }, carouselWidgetProps))
    }))
  });
};
var InventoryList = inventoryProp => {
  var _inventoryProp$testID = inventoryProp.testID,
    testID = _inventoryProp$testID === void 0 ? 'InventoryListWidget' : _inventoryProp$testID,
    id = inventoryProp.id,
    style = inventoryProp.style,
    onUserAction = inventoryProp.onUserAction,
    ctaPressMetaData = inventoryProp.ctaPressMetaData,
    onCardPressMetaData = inventoryProp.onCardPressMetaData,
    _inventoryProp$title = inventoryProp.title,
    title = _inventoryProp$title === void 0 ? '' : _inventoryProp$title,
    _inventoryProp$descri = inventoryProp.description,
    description = _inventoryProp$descri === void 0 ? '' : _inventoryProp$descri,
    _inventoryProp$ctaTex = inventoryProp.ctaText,
    ctaText = _inventoryProp$ctaTex === void 0 ? '' : _inventoryProp$ctaTex,
    imageUrl = inventoryProp.imageUrl;
  var _useBreakpoint2 = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint2.isSmallScreen;
  return _jsxs(View, Object.assign({
    style: [inventoryListWidgetStyles.cardContainer, style]
  }, {
    children: [_jsxs(Pressable, Object.assign({
      onPress: () => {
        isValidObject(onCardPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onCardPressMetaData), {
          item: inventoryProp
        }));
      }
    }, {
      children: [!!imageUrl && _jsx(Image, {
        source: {
          uri: imageUrl
        },
        resizeMode: 'contain',
        style: inventoryListWidgetStyles.imageContainer
      }), !!title && _jsx(Typography, Object.assign({
        text: title,
        type: "body-para-" + (isSmallScreen ? 'sm' : 'md'),
        color: BLACK_900
      }, getTestId(testID, 'title'))), !!description && _jsx(Typography, Object.assign({
        text: description,
        type: "body-para-" + (isSmallScreen ? 'xs' : 'sm'),
        color: BLACK_800
      }, getTestId(testID, 'description')))]
    })), !!ctaText && _jsx(Button, Object.assign({
      title: ctaText,
      buttonType: "alternate-dark",
      version: "fixed-padding",
      style: inventoryListWidgetStyles.buttonContainer,
      onPress: () => {
        isValidObject(ctaPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, ctaPressMetaData), {
          item: inventoryProp
        }));
      }
    }, getTestId(testID, 'button')))]
  }));
};
InventoryListWidgetComponent.genericRendererKey = 'AirInventoryListWidget';